import React, { useEffect, useState } from 'react'
import Layout from '../Layout';
import { Typography, Container, Box, Grid, CircularProgress, Button } from '@material-ui/core';
import DataTable from '../Table';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomBreadcrumbs from '../Breadcrumb';
import { getAssetDeclarationFile, getAssetDeclarationHistory } from '../../ReduxStore/AssetDisposalSlice';
import { getVendorData } from '../../ReduxStore/VendorDataSlice';
import Select from 'react-select';
import * as XLSX from 'xlsx';
import GetAppIcon from '@material-ui/icons/GetApp';
import { convertUTCtoIST } from '../../helpers/DateConvert'
import { useLocation } from 'react-router-dom';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';

const customStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 9999, // Adjust this value as needed
    }),
};


const columns = [
    { id: 'Sr.no', label: 'Sr.no', minWidth: 50 },
    { id: 'vendor', label: 'Vendor Code', minWidth: 80 },
    { id: 'vendor_group', label: 'Vendor Name', minWidth: 80 },
    { id: 'user_name', label: 'Name', minWidth: 80 },
    { id: 'datetime', label: 'Date', minWidth: 150 },
    { id: 'zone', label: 'Zone', minWidth: 80 },
    { id: 'location', label: 'Location', minWidth: 100 },
    { id: 'state', label: 'State', minWidth: 100 },
    { id: 'download', label: 'Download', minWidth: 100 }
];





const AsssetDeclarationHistory = () => {
    const dispatch = useDispatch();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];
    const location = useLocation();
    const pathname = location.pathname.split('/');
    console.log("check vendor", pathname)
    const vendor = pathname[2];

    const { response } = useSelector(state => state.vendor);
    const [loading, setLoading] = useState(true);
    const [SupplierOptions, setSupplierOptions] = useState(null);
    const [selectedSupplier, setselectedSupplier] = useState(null);
    const [DecLogs, setAssetDecLogs] = useState([]);
    // const [fileUrl, setFileUrl] = useState('');
    // const [vendorDetails, setVendorDetails] = useState();
    const vendorCode = localStorage.getItem("vendorCode");
    const Role = localStorage.getItem("userRole");

    const handleDownloadFile = async (id) => {
        console.log("Downloading file for: ", id);
        try {
            const action = dispatch(getAssetDeclarationFile(id));
            const res = await action.unwrap();
            console.log("check file", res)
            if (res.response && res.response.url) {
                const fileUrl = res.response.url;
                window.open(fileUrl, '_blank');
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }



    const getAssetDecLogs = async (code) => {
        try {
            const action = dispatch(getAssetDeclarationHistory(code));
            const res = await action.unwrap();
            if (res.result) {
                // Merge each log entry with the vendor details and format datetime with timezone conversion
                const mergedLogs = res.result.declaration_logs.map(log => ({
                    ...log,
                    zone: res.result.zone,
                    location: res.result.location,
                    state: res.result.state,
                    vendor_group: res.result.vendor_group,
                    vendor: res.result.vendor,
                    datetime: convertUTCtoIST(log.datetime)

                }));
                // Sort logs by datetime in descending order (latest first)
                // const sortedLogs = mergedLogs.sort((a, b) => new Date(b.datetime) - new Date(a.datetime));

                // Sort logs by datetime in ascending order (oldest first)
                const sortedLogs = mergedLogs.sort((a, b) => new Date(a.datetime) - new Date(b.datetime));

                setAssetDecLogs(sortedLogs);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }


    const exportToExcel = () => {
        // Create a new worksheet from the data
        const worksheet = XLSX.utils.json_to_sheet(DecLogs);

        // Create a new workbook and append the worksheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Generate a buffer and trigger the download
        XLSX.writeFile(workbook, 'Asset_Declaration.xlsx');
    };

    useEffect(() => {
        const fetchData = async (vendor_code) => {
            await getAssetDecLogs(vendor_code);
            setLoading(false);
        };
        if (Role === "supplier") {
            fetchData(vendorCode);
        } else {
            fetchData(vendor);
        }

    }, [Role])

    useEffect(() => {
        if (Role === "admin") {
            dispatch(getVendorData());
            setLoading(false);
        }
    }, [Role, dispatch])


    useEffect(() => {
        // const Supplierlist = response && response.map(item => item.vendor_group);
        const Supplierlist = response && response.map(item => ({
            label: `${item.vendor_group} (${item.vendor})`, // Concatenate vendor_group and vendor
            value: item.vendor // Use vendor code as the value
        }));
        console.log("Supplierlist", Supplierlist);
        if (Supplierlist) {
            setSupplierOptions(Supplierlist.map((item, index) => ({
                value: item.value, // Use vendor as the value
                label: item.label  // Display concatenated vendor_group and vendor
            })));
        }
    }, [response]);


    useEffect(() => {
        if (selectedSupplier) {
            getAssetDecLogs(selectedSupplier.value);
        }

    }, [selectedSupplier])


    if (loading) {
        return (
          <Layout>
            <Container>
              <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                <GridLoadingSpinner />
              </Box>
            </Container>
          </Layout>
        );
      }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h5" component="h1" gutterBottom>
                        PLI Asset Declaration History
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="PLI Asset Declaration History" />
                </Box>
                <Box mb={2}>
                    <Grid container spacing={2}>
                        {Role === "admin" && <Grid item sm={3}>
                            {/* <h4>Select Supplier</h4> */}
                            <Select
                                styles={customStyles}
                                options={SupplierOptions}
                                placeholder="Select Vendor"
                                isSearchable
                                onChange={setselectedSupplier}
                                isClearable
                            />
                        </Grid>}

                        <Grid item xs={12} sm={2}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                onClick={exportToExcel}
                                endIcon={<GetAppIcon />}
                            >
                                Export Excel
                            </Button>
                        </Grid>

                    </Grid>
                </Box>
                {DecLogs.length === 0 ? (<Box display="flex" alignItems="center" justifyContent="center" mt={4}>
                    <Typography variant="h5">No Asset Declaration</Typography>
                </Box>) : (<Box mb={2}>
                    <Grid container>
                        <Grid item xs={12}>
                            <DataTable data={DecLogs} columns={columns} pagination={false} downloadFile={handleDownloadFile} />
                        </Grid>
                    </Grid>
                </Box >)
                }
            </Container >
            <ToastContainer />
        </Layout >
    )
}

export default AsssetDeclarationHistory